import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "PriceBoxList",
    component: () => (__SERVER__ ? require("./price-box-list-view") : import("./price-box-list-view"))
});

export default definition;
